import { StyleSheet, Dimensions, PixelRatio } from 'react-native';
const px1 = 1 / PixelRatio.get();
const { width, height } = Dimensions.get('window');

export default StyleSheet.create({
    mask: {
        height,
        width,
        backgroundColor: 'rgba(0,0,0, .5)'
    },
    closeWrapper: {
        position: 'absolute',
        top: 4,
        right: 4,
        padding: 5
    },
    // 自定义弹框
    modalMain: {
        position: 'absolute',
        zIndex: 10000,
        paddingTop: 24,
        left: '50%',
        top: '50%',
        marginLeft: -140,
        marginTop: -110,
        borderRadius: 10,
        // backgroundColor: 'red'
        backgroundColor: '#fff',
        width: 280
    },
    modalTitle: {
        paddingBottom: 8,
        lineHeight: 25,
        fontSize: 18,
        fontWeight: '700',
        textAlign: 'center',
        color: '#333'
    },
    modalInfo: {
        fontSize: 14,
        paddingHorizontal: 16,
        paddingBottom: 14
    },
    modalInfoText: {
        lineHeight: 20,
        color: '#333'
    },
    modalBottom: {
        paddingHorizontal: 16,
        paddingBottom: 16
    },
    btn: {
        backgroundColor: '#00D4E3',
        borderRadius: 20,
        overflow: 'hidden',
        height: 40,
        lineHeight: 40,
        textAlign: 'center',
        fontSize: 16,
        color: '#FFF'
    }
});
